/**
 * Sección de formulario en drawers, alineada al patrón de
 * TabPaymentDetails (pagos): tarjeta blanca, icono indigo y divisor.
 */
export const CourseFormSection = ({
    id,
    title,
    description,
    icon = null,
    children,
    className = '',
}) => (
    <section
        aria-labelledby={id}
        className={`rounded-lg border border-gray-200 bg-white p-5 shadow-sm ${className}`.trim()}
    >
        <div className="mb-4 flex items-start gap-2 border-b border-gray-100 pb-3">
            {icon ? (
                <span className="mt-0.5 inline-flex shrink-0 text-indigo-600" aria-hidden="true">
                    {icon}
                </span>
            ) : null}
            <div className="min-w-0">
                <h2 id={id} className="text-lg font-bold text-gray-800 text-pretty">
                    {title}
                </h2>
                {description ? (
                    <p className="mt-1 text-sm text-gray-500">{description}</p>
                ) : null}
            </div>
        </div>
        <div className="space-y-4">{children}</div>
    </section>
);

export const CourseFormGrid = ({ children, className = '' }) => (
    <div className={`grid grid-cols-1 gap-4 lg:grid-cols-2 ${className}`.trim()}>
        {children}
    </div>
);

export const CourseFormField = ({ label, htmlFor, hint, children }) => (
    <div className="w-full">
        {label ? (
            <label htmlFor={htmlFor} className="mb-2 block text-sm font-medium text-slate-700">
                {label}
            </label>
        ) : null}
        {children}
        {hint ? (
            <p className="mt-1.5 text-xs text-slate-500">{hint}</p>
        ) : null}
    </div>
);
